import * as React from 'react';

function EclipseLoading(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        shapeRendering: 'auto',
      }}
      width={48}
      height={48}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      {...props}
    >
      <path d="M10 50a40 40 0 0 0 80 0 40 42 0 0 1-80 0" fill="#fdac17">
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="1.3513513513513513s"
          repeatCount="indefinite"
          keyTimes="0;1"
          values="0 50 51;360 50 51"
        />
      </path>
    </svg>
  );
}

export default React.memo(EclipseLoading);
